import React from 'react'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'
import posed from 'react-pose'

import DesktopContainer from '~/components/DesktopContainer'
import WinItBackgroundLogos from '~/components/WinItBackgroundLogos'
import WinitSmallLogo from "~/public/static/images/svg/winIt_small_logo.svg"

const CenterContainer = styled.div`
  display: flex;
  height: 100%;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const StatusText = styled.div`
  color: ${props => props.theme.colors.text.label};
  text-align: center;
  margin-top: 1.5rem;
  font-family: ${props => props.theme.fonts.avenirNextDemi};
`

const Logo = posed.img({
  small: {
    scale: 1,
    opacity: 1,
    transition: {
      y: { type: 'physics', acceleration: 20, friction: 0.5 },
      default: { duration: 900 }
    }
  },
  big: {
    scale: 1.5,
    opacity: 0.9,
    transition: {
      y: { type: 'physics', acceleration: 30, friction: 0.1 },
      default: { duration: 900 }
    }
  }
})

@inject(all => ({
  statusText: all.store.trafficSubmission.statusText
}))
@observer
class InitializationLoader extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      interval: null,
      pose: 'small'
    }
  }

  componentDidMount() {
    this.initInterval()
  }

  componentWillUnmount() {
    this.cancelInterval()
  }

  initInterval = () => {
    const interval = setInterval(this.handleChange, 900)
    this.setState({ ...this.state, interval }) // eslint-disable-line
  }

  cancelInterval = () => {
    clearInterval(this.state.interval)
    this.setState({ interval: null })
  }

  handleChange = () => {
    if (!this.state.interval) return false
    const { pose } = this.state
    this.setState({
      ...this.state, // eslint-disable-line
      pose: pose === 'small' ? 'big' : 'small'
    })
    return true
  }

  render() {
    const { statusText } = this.props
    return (
      <WinItBackgroundLogos>
        <DesktopContainer fullHeight>
          <CenterContainer>
            <Logo pose={this.state.pose} src={WinitSmallLogo} alt="WinIt" />
            <StatusText>{statusText || 'Loading'}</StatusText>
          </CenterContainer>
        </DesktopContainer>
      </WinItBackgroundLogos>
    )
  }
}

export default InitializationLoader
